// ListBilling.jsx
import React from "react";
import { Table } from "semantic-ui-react";
import { size, map } from "lodash";
import { BillingItem } from "../BillingItem";
import "./ListBilling.scss";

export function ListBilling(props) {
  const { billings, onReload } = props;

  if (!billings) return null;
  if (size(billings) === 0) return <h2>No hay facturas</h2>;

  return (
    <Table compact celled className="list-billing">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Cliente</Table.HeaderCell>
          <Table.HeaderCell>Contacto</Table.HeaderCell>
          <Table.HeaderCell>Número</Table.HeaderCell>
          <Table.HeaderCell>Descripción</Table.HeaderCell>
          <Table.HeaderCell>Total</Table.HeaderCell>
          <Table.HeaderCell>Margen</Table.HeaderCell>
          <Table.HeaderCell>Estado</Table.HeaderCell>
          <Table.HeaderCell>Factura Institución</Table.HeaderCell>
          <Table.HeaderCell>Factura Partner</Table.HeaderCell>
          <Table.HeaderCell>Fecha de Alta</Table.HeaderCell>
          <Table.HeaderCell>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {map(billings, (billing) => (
          <BillingItem
            key={billing._id}
            billing={billing}
            onReload={onReload}
          />
        ))}
      </Table.Body>
    </Table>
  );
}
